import {
  Wrench,
  Zap,
  Flame,
  Refrigerator,
  Home,
  Droplets,
  Bug,
  ShieldAlert,
  Trash2,
  TreePine,
  Volume2,
  Hammer,
  Search,
  HelpCircle,
} from 'lucide-react';

export const CATEGORY_ICONS = {
  'Plumbing': Wrench,
  'Electrical': Zap,
  'Heating / Boiler': Flame,
  'Appliances': Refrigerator,
  'Structural': Home,
  'Damp / Mould': Droplets,
  'Pest Control': Bug,
  'Safety': ShieldAlert,
  'Cleaning / Waste': Trash2,
  'Garden / Exterior': TreePine,
  'Noise / Neighbour': Volume2,
  'General Maintenance': Hammer,
  'Inspection Required': Search,
  'Other': HelpCircle,
};